import { Person } from "@turizi/shared";
import { TagIcon } from "@/lib/tag-utils";
import {
    IconMail,
    IconPhone,
    IconMapPin,
    IconId,
    IconDiscount,
    IconFileDescription
} from "@tabler/icons-react";
import { Badge, Button, CopyButton } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { SkeletonListWithFilters } from "./snippets";

interface Props {
    person: Person;
    isLoading?: boolean;
    className?: string;
}

export default function PersonHeader({
    person,
    isLoading = false,
    className
}: Props): JSX.Element | null {
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className={className || 'solid-box-border p-4'}>
                <SkeletonListWithFilters />
            </div>
        );
    }

    if (!person) {
        return null;
    }

    return (
        <div className={className || 'flex flex-col sm:flex-row sm:items-end gap-3 sm:gap-6 md:gap-8 p-4 bg-gray-50 rounded-xl border border-gray-100 shadow-md'}>
            {/* Header Title & Badges Section (Left Aligned, No justify-between) */}
            <div className="flex items-start gap-3 min-w-0 w-full sm:w-auto">
                <div className="shrink-0 flex flex-col items-center">
                    {person.category && (
                        <TagIcon
                            name={person.category}
                            size="md"
                            hideText
                        />
                    )}
                    <span className="text-[10px] text-gray-600  tracking-tight mt-0.5">
                        #{person.id}
                    </span>
                </div>

                <div className="min-w-0 flex-1">
                    <div className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        {t(person.category)}
                    </div>
                    <div className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight">
                        {person.name} <span className="font-light">{person.observations}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
